import { render, staticRenderFns } from "./MovementIndex.vue?vue&type=template&id=11124771&"
import script from "./MovementIndex.vue?vue&type=script&lang=js&"
export * from "./MovementIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports